import { jsx, jsxs } from 'react/jsx-runtime';
import { Provider, Viewport } from './../../../external/@radix-ui/react-toast/dist/index.js';
import { createContext, useContext, useState, useMemo } from 'react';
import { uuid } from '../../util/str.js';
import { ToastDuration } from './constants.js';
import { Toast } from './toast.js';

const useToast = () => useContext(ToastContext);
const MAX_TO_DISPLAY = 5;
const DEFAULT_CONFIG = {
    duration: ToastDuration.NORMAL,
};
const missingToastProvider = 'You forgot to wrap your app in <ToastProvider>';
const ToastContext = createContext({
    get showToast() {
        throw new Error(missingToastProvider);
    },
});
function ToastContextProvider({ children, }) {
    const [toasts, setToasts] = useState([]);
    const handleCloseToast = (id) => {
        setToasts((oldToasts) => oldToasts.filter((current) => current.id !== id));
    };
    const context = useMemo(() => ({
        showToast: (config) => {
            const mergedConfig = { ...DEFAULT_CONFIG, ...config, id: uuid() };
            setToasts((oldToasts) => [...oldToasts, { ...mergedConfig }]);
        },
    }), []);
    return (jsx(ToastContext.Provider, { value: context, children: jsxs(Provider, { children: [children, toasts
                    .slice(Math.max(0, toasts.length - MAX_TO_DISPLAY))
                    .map(({ type, message, duration, id }) => (jsx(Toast, { open: true, duration: duration, onOpenChange: () => {
                        handleCloseToast(id);
                    }, onEscapeKeyDown: () => handleCloseToast(id), type: type, message: message }, id))), jsx(Viewport, { className: "fixed inset-x-0 bottom-0 mx-2 max-w-2xl lg:mx-auto" })] }) }));
}

export { ToastContext, ToastContextProvider, useToast };
//# sourceMappingURL=provider.js.map
